$(document).ready(function () {

  var minutes = 15;
  var seconds = 0;

  var timer; // Will hold the timer 
  var shopify_clear = 0;
  function countDown() {
    //clear_checkout();
    clearInterval(timer); // Just incase 

    timer = setInterval(function(){

      // This function will occur every second 
      if (seconds > 0) { 
        seconds--;
      } 
      else if (minutes > 0) { 
        seconds = 59; 
        minutes--;
      } 
      else {
        if(shopify_clear == 0) {
          if($("#cart-timer").length) {
            $('#cart-timer').html("0m:0s");
            $.ajax({
              type: "POST",
              url: '/cart/clear.js',
              data: '',
              //success: success,
              dataType: 'json',
              success: function() { 
                //return Shopify.clear();

              },
              error: function(XMLHttpRequest, textStatus) {

              }
            });
          }
          clearInterval(timer);
        }
        $('#clockdiv').html("0m:0s");
        shopify_clear += 1;
      }  

      // Show the time left
      $('#clockdiv').html(minutes + "m:" + seconds + "s");
      if($("#cart-timer").length) {
        $('#cart-timer').html(minutes + "m:" + seconds + "s");
      }
    }, 1000);
  }
  function resetTimer() {
    timer;
    clearInterval(timer);

    // Reset time 
    minutes = 15;
    seconds = 0;

    // Show the time left
    $('#clockdiv').html(minutes + "m:" + seconds + "s");
    if($("#cart-timer").length) {
      $('#cart-timer').html(minutes + "m:" + seconds + "s");
    }
  }

  /**/
  /*var quickcartchckdata = [];
  $.ajax({ 
    type: 'GET',
    url: '/cart.js',
    async: false, 
    cache: false, 
    dataType: 'json',
    success: function (json) {
      quickcartchckdata = json;
    }
  });
  if(quickcartchckdata.indexOf('Discountcustom') !== -1) {

  }*/
  /**/

  /**/
  var main_options = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '#productModal .other-image ul'
  }

  var thumb_options = {
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '#productModal .main-nav-slider',
    dots: false,
    arrows: false,
    infinite: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },     
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      { 
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  }
  /**/

  var moneyFormat = theme.moneyFormat;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
  var quickview = $('.shop_pr .quickview-container-wrap .quickview');

  var main_image=$('#productModal .modal-body .product-images .main-nav-slider'),

      main_href=$('#productModal .modal-body .product-images .main-image a'),

      other_image=$('#productModal .modal-body .product-images .other-image  ul'),

      rating=$('#productModal .modal-body .product-desc .rating'),

      modal_title=$('#productModal .modal-body .product-info .qckview-title-wrap'),

      price=$('#productModal .modal-body .product-info .price-box .price'),

      check_options=$('#productModal .modal-body .product-info .select-options-label'),

      option_selectors_wrapper=$('#productModal .modal-body .product-info .option-selectors-wrapper'),

      modal_desc=$('#productModal .modal-body .product-info .quick-desc'),

      main_desc_href=$('#productModal .modal-body .product-info .see-all'),

      share=$('#productModal .modal-body .product-info .social-sharing'),

      btn_add=$('#productModal .modal-body .product-info .quick-add-to-cart .single_add_to_cart_button');

  var field_add=$('#productModal .modal-body .product-info .quick-add-to-cart #id');

  var sub_btn_add=$('#productModal .modal-body .product-info .shop-btns .popup-cart-btn');

  var ajax_err_msg=$('#productModal .modal-body .ajax-cart-err-msg-wrap');

  var ajax_success_msg=$('#productModal .modal-body .ajax-cart-succ-msg-wrap');

  var in_stock=$('#productModal .modal-body .qckview-product-in-stck');

  var cart_btn=$('#productModal .modal-body .popup-cart-btn');
  var per_diff = $('#productModal .modal-body .percent-diff'); 

  btn_compare=$('#productModal .modal-body .product-info .button-group .btn-compare');

  btn_wishlist=$('#productModal .modal-body .product-info .button-group .btn-wishlist'); 		

  $('body').on('click', '.quickview', function (){
    if(main_image.hasClass('slick-initialized')) {
      main_image.slick("unslick");
    }

    if(other_image.hasClass('slick-initialized')) {
      other_image.slick("unslick");
    }
    other_image.empty();
    main_image.empty();
    main_image.html('');
    other_image.html('');

    rating.empty();

    price.empty();

    ajax_err_msg.empty();

    ajax_success_msg.empty();

    var arr_image='';
    var new_images='';

    var product_info=$(this).data('productinfo');

    var product_var_available=$(this).data('var-'+product_info['variants'][0]['id']);

    var product_linked_url = $(this).data('linkedurl');

    if (product_info['images'].length == 1) {
      $('#productModal .main-nav-slider').addClass('one-image');
      $('#productModal .other-images-wrap ul').addClass('one-image');
    }
    else {
      $('#productModal .main-nav-slider').removeClass('one-image');
      $('#productModal .other-images-wrap ul').removeClass('one-image');
    }

    //console.log(product_info['images']);
    if (product_info['images'].length) {
      new_images=product_info['images'];
      for(var i=0;i<new_images.length;i++) {
        //console.log(main_image.html());
        main_image.append('<div class="main-image images"><img alt="" src="'+new_images[i]+'" class="img-responsive"></div>');
      }
    }
    else {
      main_image.append('<div class="main-image images"><img alt="" src="" class="img-responsive"></div>');
    }

    main_href.attr('href','/products/'+product_info['handle']);

    main_desc_href.attr('href','/products/'+product_info['handle']);

    arr_image=product_info['images'];

    for(var i=0;i<arr_image.length;i++) {
      other_image.append('<li style="display: table;width: 70px;padding: 0 5px;"><span style="width:70px;border: 1px solid #000;height: 70px;display: table-cell;vertical-align: middle;cursor:pointer;padding: 0 5px;"><img class="other-image" src="'+arr_image[i]+'"></span></li>');
    }

    var prodtitle = product_info['title'].split('_');
    modal_title.html("<span>"+ prodtitle[0] +"</span>" );
    var desc = '';
    var res = '';
    //console.log($(product_info['description']).html());
    //console.log($.parseHTML(product_info['description']));
    var get_html_object = $('<div>').append($.parseHTML(product_info['description']));

    /*if ($(product_info['description']).html() !== undefined) {
      if($(product_info['description']).html().indexOf("<!-- mobsplit -->") !== -1) {
        desc = $(product_info['description']).html().split("<!-- mobsplit -->")[1];
      }
      else {
        desc = $(product_info['description']).html().split("<!-- split -->")[0];
      }
      res = desc.trim();
    }
    else {
      res = '';
    }*/

    if ($(product_info['description']).html() !== undefined) {
      if($(get_html_object).html().indexOf("<!-- quicksplit -->") !== -1) {
        desc = $(get_html_object).html().split("<!-- quicksplit -->")[1];
      }
      res = desc.trim();
    }

    main_image.slick(main_options);
    other_image.slick(thumb_options);
    main_image.slick('slickGoTo', 1);
    other_image.slick('slickGoTo', 1);

    /*console.log(main_image.html());
    console.log(other_image.html());*/

    setTimeout(function(){other_image.slick("refresh");}, 1000);

    $(field_add).val(product_info['variants'][0]['id']);
    modal_desc.html(res);
    //modal_desc.html(get_html_object);
    rating.append('<span class="shopify-product-reviews-badge" data-id="'+ product_info["id"] +'"></span>');

    if(product_info['price']){	
      if(product_info['compare_at_price']){ 			
        price.append('<span class="old-price">'+ formatMoney(product_info["compare_at_price"], moneyFormat) +'</span><span class="new-price">'+ formatMoney(product_info['price'], moneyFormat) +'</span>');
      }
      else{
        price.append('<span class="new-price">'+ formatMoney(product_info['price'], moneyFormat) +'</span>');
      }
    }

    $(sub_btn_add).html('<span id="AddToCartText-product-template">Add to Cart</span>');

    if (product_info['variants'].length > 1 && product_info['options'].length > 0) {
      var variants_html = '';
      var get_numbers_to_serve = ''
      product_info['variants'].forEach(function(a,b){
        get_numbers_to_serve = product_info['variants'][0]['title'].match(/\d+/);
        variants_html += '<li class="variants-wrapper" data-vid="'+a.id+'" data-vtitle="'+a.title+'" data-vavailability="'+a.available+'" data-vprice="'+a.price+'" data-vcomprice="'+a.compare_at_price+'" data-voption1="'+a.option1+'" data-voption2="'+a.option2+'" data-voption3="'+a.option3+'">'+a.title+'</li>'
      });
      //option_selectors_wrapper.html('<div class="dropdown"><button class="custom-variant-wrap dropdown-toggle" type="button" data-toggle="dropdown">'+product_info['variants'][0]['option1']+'<span class="caret"></span></button><ul class="dropdown-menu">'+variants_html+'</ul></div>');
      option_selectors_wrapper.html('<a class="quick-see-more" href="'+product_linked_url+'">See More</a>');
    }

    btn_add.attr('href','/products/'+product_info['handle']);
    //console.log(product_info['variants'][0]['id']);
    //console.log(parseInt(field_add.val()));
    if(product_var_available === false && product_info['variants'][0]['id'] == parseInt(field_add.val())) {
      cart_btn.find('span').html('sold out');
      cart_btn.attr('disabled',true);
      in_stock.html('Out of stock');
      in_stock.addClass('qckview-out-of-stock');
    }
    else {
      cart_btn.find('span').html('add to cart');
      cart_btn.attr('disabled',false);
      in_stock.html('In stock and ready to ship');
      in_stock.removeClass('qckview-out-of-stock');
    }
    var old__price = product_info["compare_at_price"];
    var new__price = product_info['price'];

    var per_pricee = (old__price - new__price) * 100 / old__price;
    var round_per_pricee = Math.round(per_pricee);
    if(old__price > new__price){
      //per_diff.text(round_per_pricee+'%');
      var get_disc_img = "//cdn.shopify.com/s/files/1/0253/3923/2330/t/1/assets/discount-icon.png?v=134833856108246523981569400962";
      per_diff.html('<span class="disc-img-wrap"><img src="'+get_disc_img+'"></span><span class="disc-txt-qck-wrap">'+round_per_pricee+'%</span>');
      per_diff.css("opacity","1");	
    }else{
      per_diff.css("opacity","0");
      per_diff.text('0%');
    }  
    //  console.log('per_pricee'+ Math.round(per_pricee));

  });

  $(document).on("click", ".popup-cart-btn", function(event) {
    event.preventDefault();
    var form = $(this).closest('form');
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      success: function(cart) {
        //ajaxCart.updatecart(cart);
        ajax_success_msg.html('Item added to cart!');
        var quickviewdata = [];
        $.ajax({ 
          type: 'GET',
          url: '/cart.js',
          async: false, 
          cache: false, 
          dataType: 'json',
          success: function (json) {
            quickviewdata = json;
            resetTimer();
            countDown();
          }
        });
        $('.cart-main-wrap .items-cnt span').html(quickviewdata.item_count);
        $('.mob-cart-wrap .mob-items-cnt span').html(quickviewdata.item_count);
        //clear_checkout();
      },
      error: function(jqXHR, textStatus, errorThrown) {
        var response = $.parseJSON(jqXHR.responseText);
        //alert("An error occurred: can't reach server");
        //console.log(XMLHttpRequest.responseText.description);
        //console.log(textStatus);
        ajax_err_msg.html(response.description);
      },
    });
  });

  $(document).on("click", ".variants-wrapper", function(event) {
    var get_var = parseInt($(this).data('vid'));
    var get_title = $(this).data('vtitle');

    $(this).closest('.dropdown').find('.custom-variant-wrap').html(get_title+'<span class="caret"></span>');
    $(this).closest('form').find('#id').val(get_var);
  });

});